<template>
  <li class="col-12 c-sm:col-6 c-xl:c-px-4 c-mb-6">
    <div class="row c-items-center c-justify-center relative">
      <!-- Bubble image -->
      <div class="col-3 c-sm:col-5 absolute top-0 left-0 c-px-0 mt-n1 c-sm:c-mt-7 c-lg:c-mt-6">
        <div class="embed-responsive embed-responsive-1by1 bg-light opacity-40 pattern-2" />
      </div>
      <!-- Image -->
      <div class="col-4 c-sm:col-6 c-xl:col-3 c-lg:c-px-0 c-self-start">
        <div class="embed-responsive embed-responsive-1by1 c-mb-0 c-sm:c-mb-2">
          <Component
            :is="getSvgBySystemName(benefit.systemName)"
            class="icon embed-responsive-item image-contain c-p-1 c-sm:c-p-0"
            lazy
          />
        </div>
      </div>
      <!-- Title + description -->
      <div class="col-8 c-sm:col-12 c-sm:text-center">
        <h4 class="c-mb-2 text-success">
          {{ benefit.title }}
        </h4>
        <p class="c-mb-0 text-sm-c">
          {{ benefit.description }}
        </p>
      </div>
    </div>
  </li>
</template>

<script setup>
import { getSvgBySystemName } from '@/components/svg/properties/propertiesSvgs'

defineProps({
  benefit: {
    type: Object,
    required: true,
  },
})
</script>
